<template>
  <v-container fluid>
    <v-data-table
        :expanded.sync="expanded"
        :headers="headers"
        :items="data"
        :items-per-page="itemsPerPage"
        :loading="loading"
        :page.sync="page"
        :search="search"
        class="elevation-1"
        item-key="id"
        loading-text="Loading"
        show-expand
        sort-by="calories"
        hide-default-footer
        @page-count="pageCount = $event"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <search @search="searchItem($event)"/>
          <v-spacer/>
          <dialog-form
              v-model="dialog"
              :accept-button-loading="saveLoading"
              :btn-titles="{
                  declined: 'Отмена',
                  confirmed: 'Сохранить'
                }"
              :close-on-accept="false"
              :external-valid="isModelPermissionsValid"
              :fields="fields"
              :model="model"
              :title="m => m.id ? 'Редактирование роли' : 'Создание роли'"
              max-width="900px"
              @confirmed="save"
              @declined="model = {}"
          >
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" class="mb-2" color="primary" v-show="$store.getters.checkAccess({permission:'ROLE', c: true})">Create new role</v-btn>
            </template>

            <template v-slot:permissions>
              <v-data-table
                  :headers="permissionHeaders"
                  :items="permissionRole"
                  :items-per-page="permissionRole.length"
                  :value="model.permissions"
                  dense
                  group-by="name.screenType.value"
                  hide-default-footer
                  item-key="id"
                  show-select
                  @input="setPermissions"
                  style="width: 100%"
              >
                <template v-slot:group.header="{ group, headers }">
                  <td :colspan="headers.length" class="mx-0 my-0 px-0 py-0">
                    <v-banner class="ma-0" color="primary" dark rounded>
                      {{ screenMap[group].description }}
                    </v-banner>
                  </td>
                </template>

                <template v-slot:item.read="{ item }">
                  <v-checkbox v-model="(permissionMap[item.id] || {}).read" :disabled="!permissionMap[item.id]" dense/>
                </template>

                <template v-slot:item.create="{ item }">
                  <v-checkbox v-model="(permissionMap[item.id] || {}).create" :disabled="!permissionMap[item.id]"
                              dense/>
                </template>

                <template v-slot:item.update="{ item }">
                  <v-checkbox v-model="(permissionMap[item.id] || {}).update" :disabled="!permissionMap[item.id]"
                              dense/>
                </template>

                <template v-slot:item.delete="{ item }">
                  <v-checkbox v-model="(permissionMap[item.id] || {}).delete" :disabled="!permissionMap[item.id]"
                              dense/>
                </template>

              </v-data-table>
            </template>
          </dialog-form>
          <confirm-dialog v-model="removePromiseGetter"/>
        </v-toolbar>
        <v-divider/>
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length" style="padding: 0">
          <v-card-text>
            <v-data-table
                :headers="permissionHeaders"
                :items="item.permissions"
                :items-per-page="1000"
                dense
                hide-default-footer
                item-key="id"
                group-by="name.screenType.value"
            >
              <template v-slot:item.read="{ item }">
                <v-checkbox v-model="item.read" dense readonly/>
              </template>

              <template v-slot:item.create="{ item }">
                <v-checkbox v-model="item.create" dense readonly/>
              </template>

              <template v-slot:item.update="{ item }">
                <v-checkbox v-model="item.update" dense readonly/>
              </template>

              <template v-slot:item.delete="{ item }">
                <v-checkbox v-model="item.delete" dense readonly/>
              </template>

              <template v-slot:group.header="{ group, headers }">
                <td :colspan="headers.length" class="mx-0 my-0 px-0 py-0">
                  <v-banner class="ma-0" color="primary" dark rounded>
                    {{ screenMap[group].description }}
                  </v-banner>
                </td>
              </template>
            </v-data-table>
          </v-card-text>
        </td>
      </template>
      <template v-slot:item.actions="{ item }">
        <div class="text-right">
          <v-btn class="mx-2" color="primary" dark fab x-small @click="editItem(item)" v-show="$store.getters.checkAccess({permission:'ROLE', u: true})">
            <v-icon dark>edit</v-icon>
          </v-btn>
          <v-btn class="mx-2" color="primary" dark fab x-small @click="deleteItem(item)" v-show="$store.getters.checkAccess({permission:'ROLE', d: true})">
            <v-icon dark>delete</v-icon>
          </v-btn>
        </div>
      </template>
      <template v-slot:no-data>
        <v-alert :value="true" color="primary" dark icon="help">
          No data to display :(
        </v-alert>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import {mapActions} from 'vuex';
import rules from "../api/rules";

export default {
  components: {
  },
  data: () => ({
    search: '',
    pagVal: [10, 20, 50, 100],
    loading: false,
    saveLoading: false,
    dialog: false,
    rules: rules,
    valid: true,
    page: 1,
    pageCount: 0,
    itemsPerPage: 99999,
    headers: [
      {text: 'id', value: 'id'},
      {text: 'name', value: 'name', width: '25%'},
      {text: 'description', value: 'description', width: '50%'},
      {text: '', value: 'data-table-expand'},
      {text: '', value: 'actions', sortable: false},
    ],
    permissionHeaders: [
      {text: 'Name', value: 'name.description', sortable: false},
      {text: 'Read', value: 'read', sortable: false},
      {text: 'Create', value: 'create', sortable: false},
      {text: 'Update', value: 'update', sortable: false},
      {text: 'Delete', value: 'delete', sortable: false},
    ],
    removePromiseGetter: null,
    data: [],
    expanded: [],
    permissionRole: [],
    model: {},
    screenMap: {},
  }),
  computed: {
    fields() {
      return {
        name: {
          type: String,
          label: 'Name',
          rules: [rules.required],
        },
        description: {
          type: String,
          label: 'Description',
          rules: [],
        },
        permissions: {
        }
      }
    },
    permissionMap() {
      return this.model.permissions?.reduce((ac, cur) => {
        ac[cur.id] = cur
        return ac;
      }, {}) || {}
    },
    isModelPermissionsValid() {
      return true;
    },
  },

  created() {
    this.initialize()
  },

  methods: {
    ...mapActions(['setGlobalErrorMessage']),
    checkBoxInRow(val) {
      if (val) {
        if (!!val.create && !!val.read && !!val.update && !!val.delete) return "check_box"
        else if (!val.create && !val.read && !val.update && !val.delete) return "check_box_outline_blank"
        else return "indeterminate_check_box"
      } else return "check_box_outline_blank"
    },
    setPermissionsForRow(val) {
      if (val) {
        console.log(val)
        console.log(this.permissionMap)
        let pm = this.permissionMap[val]
        if (!!pm.create && !!pm.read && !!pm.update && !!pm.delete) {
          this.permissionMap[val].create = false
          this.permissionMap[val].read = false
          this.permissionMap[val].update = false
          this.permissionMap[val].delete = false
        } else {
          this.permissionMap[val].create = true
          this.permissionMap[val].read = true
          this.permissionMap[val].update = true
          this.permissionMap[val].delete = true
        }
      }
    },
    setPermissions: function (permissions) {
      const setAccess = (perm, val) => {
        perm.create = val;
        perm.read = val;
        perm.update = val;
        perm.delete = val;
      }

      if (this.model.permissions) {
        permissions.forEach(p => {
          let perm = this.permissionMap[p.id];
          if (perm) {
            Object.assign(p, perm)
          } else {
            setAccess(p, true)
          }
        })
      } else {
        permissions.forEach(perm => setAccess(perm, true))
      }

      this.model = {...this.model, permissions}
    },
    searchItem(event) {
      this.search = event
    },
    initialize() {
      this.loading = true
      Promise.all([
        this.$http.get("/role")
            .then(
                r => this.data = r.data.map(v => {
                  v.permissions = v.permissions.map(p => {
                    p.create = !!(p.operationPermissions & 0b1000)
                    p.read = !!(p.operationPermissions & 0b0100)
                    p.update = !!(p.operationPermissions & 0b0010)
                    p.delete = !!(p.operationPermissions & 0b0001)
                    return p;
                  })
                  return v;
                }),
                e => this.$store.dispatch('setGlobalErrorMessage', e.response.data)
            ),
        this.$http.get("role/permissions")
            .then(
                r => {
                  this.permissionRole = r.data
                  this.screenMap = r.data.reduce((acc, cur) => {
                    acc[cur.name.screenType.value] = cur.name.screenType
                    return acc;
                  }, {})
                },
                e => this.$store.dispatch('setGlobalErrorMessage', e.response.data))
      ]).finally(() => this.loading = false);
    },

    editItem(item) {
      this.model = {...item};
      this.dialog = true
    },

    deleteItem(item) {
      this.removePromiseGetter = () => new Promise(resolve => {
        this.$http.delete("/role?roleId=" + item.id)
            .then(this.initialize, e => this.$store.dispatch('setGlobalErrorMessage', e.response.data))
            .finally(resolve);
      });
    },

    save(model) {
      this.saveLoading = true
      this.$http.post("/role", {
        ...model,
        permissions: model.permissions.map(v => {
          let op = 0;
          if (v.create) op |= 0b1000
          if (v.read) op |= 0b0100
          if (v.update) op |= 0b0010
          if (v.delete) op |= 0b0001
          return {...v, operationPermissions: op}
        })
      })
          .then(() => {
                this.dialog = false;
                this.model = {};
                this.initialize();
              },
              e => {
                if (e?.response?.status === 400) {
                  this.setGlobalErrorMessage(e.response?.data?.message)
                } else {
                  this.setGlobalErrorMessage(e)
                }
              }
          ).finally(() => this.saveLoading = false)
    },
  },
};
</script>
